import { useEffect } from 'react'

const MAX_OFFSET = 36;

export const useHeaderScrollOffset = () => {

  useEffect(() => {

    let previousOffset = -1;

    const onScrollHandler = () => {
      const offset = window.scrollY < MAX_OFFSET ? window.scrollY : MAX_OFFSET;
      if (offset !== previousOffset) {
        previousOffset = offset;
        document.documentElement.style.setProperty('--header-scroll', `${offset}px`);
      }
    };

    window.addEventListener('scroll', onScrollHandler, false);
    onScrollHandler();

    return () => {
      window.removeEventListener('scroll', onScrollHandler, false);
    }
  }, []);
}
